export const translations = {
  en: {
    nav: {
      events: "Live Sports",
      concept: "Our Story",
      menus: "Menus",
      reviews: "Reviews",
      location: "Find Us",
      bookTable: "Book a Table",
    },
    hero: {
      imageAlt: "The sunlit terrace at Monte Sol",
      overline: "Vilamoura · Since 2004",
      headline: "The Art of the Stone Steak.",
      headlineAccent: "Monte Sol:",
      subheadline: "A Vilamoura tradition for over 20 years. From our iconic English Breakfast to premium cuts on hot volcanic stone.",
      ctaMenu: "Explore Menus",
      ctaBook: "Reserve a Table",
      scroll: "Discover More",
    },
    concept: {
      imageAlt: "The dining room at Monte Sol",
      overline: "The Concept",
      title: "A sun-drenched terrace,\ntwo ways to gather.",
      quote: "Family-run since 2004 — serving one table at a time.",
      signatureNote: "A Mediterranean garden in the heart of Vilamoura — where the sun sets over stone and tradition meets the grill.",
      paragraph1: "By day, enjoy our garden terrace as a Mediterranean Café & Snack Bar. Famous for our Full English Breakfast, fresh garden brunch, and golden-hour cocktails.",
      paragraph2: "By night, the ritual begins. A hot volcanic stone is brought to your table for a unique DIY grilling experience. You finish the cooking, we pour the wine.",
      highlights: [
        { label: "Established", value: "2004" },
        { label: "Address", value: "Vilamoura, Algarve" },
        { label: "Signature", value: "Stone Steak" },
        { label: "Vibe", value: "Rustic-Chic Garden" },
      ],
    },
    menu: {
      overline: "The Menu",
      title: "From sunrise coffee\nto midnight embers.",
      subtitle: "Two kitchens, one garden. Explore our day café and our evening steakhouse.",
      tabDay: "Day · Café & Snacks",
      tabNight: "Night · Stone Steak House",
      dayHours: "10:00 — 18:00",
      nightHours: "18:00 — 00:00",
      dayDescription: "Slow mornings, garden brunches and golden-hour cocktails.",
      nightDescription: "Volcanic stone, red wine and the ritual of a memorable dinner.",
      categories: {
        breakfast: "Breakfast & Brunch",
        snacks: "Snacks & Light Bites",
        cocktails: "Cocktails",
        spirits: "Spirits & Long Drinks",
        starters: "Starters",
        mains: "Mains on the Stone",
        desserts: "Homemade Desserts",
      },
      ctaBook: "Reserve Your Table",
      pricelessNote: "Seasonal selection — ask your waiter for daily specials.",
    },
    reviews: {
      overline: "Guest Stories",
      title: "Five stars,\none warm table.",
      subtitle: "What travelers from the Marina and beyond keep coming back to.",
      badge: "Google Reviews · 4.8",
    },
    location: {
      overline: "Find Us",
      title: "At the foot of the hill,\nminutes from the Marina.",
      address: "Vilamoura, Quarteira",
      country: "Algarve, Portugal",
      phone: "+351 963 314 690",
      hoursTitle: "Opening Hours",
      hoursLine1: "Tuesday — Sunday · 10:00 — 00:00",
      hoursLine2: "Kitchen closes at 22:00",
      hoursLine3: "Closed on Mondays",
      openMaps: "Get Directions",
      callUs: "Call Us",
      whatsapp: "WhatsApp Us",
    },
    footer: {
      tagline: "Mediterranean by day. Stone-fired by night.",
      quickLinks: "Quick Links",
      contact: "Contact",
      follow: "Since 2004 · Vilamoura",
      madeBy: "Made by",
      agency: "Soluções Romanas",
      rights: "All rights reserved.",
    },
    whatsappMessage: "Hello! I would like to book a table at Monte Sol Stone Steak House.",
    fullMenu: {
      overline: "Full Menu",
      title: "The Full Collection.",
      subtitle: "From Algarvian starters to our signature desserts. All our ingredients are seasonal and locally sourced.",
      seasonalNote: "Ask about today's fresh market specials",
      subCategories: { pizzas: "Pizzas", kids: "Kid's Menu" },
      itemsLabel: "items",
    },
    inVilamoura: "In Vilamoura",
    food: {
      "overline": "FROM OUR KITCHEN",
      "title": "Monte Sol favourites.",
      "subtitle": "From the hot stone to Mediterranean flavours.",
      "cta": "VIEW FULL MENU",
      "swipe": "Swipe to discover",
      "previous": "Previous dish",
      "next": "Next dish",
      "dishes": {
            "stone-steak": "Stone Steak",
            "monkfish-prawn-skewer": "Monkfish Kebab with Prawns",
            "t-bone": "T-Bone Steak",
            "monkfish-curry": "Monkfish Curry",
            "garlic-prawns": "Garlic Prawns"
      }
},
    events: {
      "overline": "LIVE SPORTS",
      "title": "Big moments. Better around a table.",
      "paragraph": "Golf, Formula 1, MotoGP, football and selected major sporting events shown live on our screens.",
      "supporting": "Ask us what’s on today.",
      "cta": "WHAT’S ON TODAY?",
      "whatsappMessage": "Hello! I would like to know which sporting events you are showing today at Monte Sol.",
      "sports": {
            "golf": "Golf",
            "formula1": "Formula 1",
            "motogp": "MotoGP",
            "football": "Football"
      }
},
  },
  pt: {
    nav: {
      events: "Desporto ao Vivo",
      concept: "O Conceito",
      menus: "Menus",
      reviews: "Avaliações",
      location: "Onde Estamos",
      bookTable: "Reservar Mesa",
    },
    hero: {
      imageAlt: "A esplanada do Monte Sol ao sol",
      overline: "Vilamoura · Desde 2004",
      headline: "A Arte do Bife na Pedra.",
      headlineAccent: "Monte Sol:",
      subheadline: "Uma tradição em Vilamoura há mais de 20 anos. Sabores autênticos — do clássico Pequeno Almoço Inglês aos cortes premium na pedra vulcânica.",
      ctaMenu: "Ver Menu",
      ctaBook: "Reservar Mesa",
      scroll: "Descobrir",
    },
    concept: {
      imageAlt: "A sala de refeições do Monte Sol",
      overline: "O Conceito",
      title: "Uma esplanada ao sol,\nduas formas de estar.",
      quote: "Tradição familiar desde 2004 — uma mesa de cada vez.",
      signatureNote: "Um refúgio mediterrânico no coração de Vilamoura — onde o sol se põe sobre a pedra e a tradição se sente ao pormenor.",
      paragraph1: "De dia, a nossa esplanada convida a relaxar como Café Mediterrânico & Snack-Bar. Conhecida pelo lendário Pequeno Almoço Inglês, brunch fresco da horta e cocktails ao pôr-do-sol.",
      paragraph2: "À noite, o ritual ganha vida. Uma pedra vulcânica quente chega à mesa para uma experiência única de grelhados. Você dá o ponto à carne, nós servimos o vinho.",
      highlights: [
        { label: "Fundado", value: "2004" },
        { label: "Local", value: "Vilamoura, Algarve" },
        { label: "Especialidade", value: "Bife na Pedra" },
        { label: "Ambiente", value: "Jardim Rústico-Chic" },
      ],
    },
    menu: {
      overline: "A Nossa Carta",
      title: "Do café da manhã\nàs brasas da noite.",
      subtitle: "Duas cozinhas, um mesmo jardim. Alterne entre o café de dia e o steakhouse à noite.",
      tabDay: "Dia · Snacks & Pequeno-Almoço",
      tabNight: "Noite · Bife na Pedra",
      dayHours: "10:00 — 18:00",
      nightHours: "18:00 — 00:00",
      dayDescription: "Matinas relaxadas, brunches no jardim e cocktails ao pôr-do-sol.",
      nightDescription: "Pedra vulcânica, vinho tinto e o ritual de um jantar memorável.",
      categories: {
        breakfast: "Pequeno Almoço & Brunch",
        snacks: "Snacks & Petiscos",
        cocktails: "Cocktails",
        spirits: "Bebidas & Long Drinks",
        starters: "Entradas",
        mains: "Grelhados na Pedra",
        desserts: "Sobremesas Caseiras",
      },
      ctaBook: "Reserve a Sua Mesa",
      pricelessNote: "Menu sazonal — consulte as nossas sugestões do dia.",
    },
    reviews: {
      overline: "Histórias de Clientes",
      title: "Cinco estrelas,\numa mesa calorosa.",
      subtitle: "O que os viajantes de Portimão e da Marina continuam a procurar.",
      badge: "Google Reviews · 4.8",
    },
    location: {
      overline: "Encontre-nos",
      title: "Aos pés da colina,\na minutos da Marina.",
      address: "Vilamoura, Quarteira",
      country: "Algarve, Portugal",
      phone: "+351 963 314 690",
      hoursTitle: "Horário",
      hoursLine1: "Terça — Domingo · 10:00 — 00:00",
      hoursLine2: "Cozinha encerra às 22:00",
      hoursLine3: "Encerrado à Segunda-feira",
      openMaps: "Como Chegar",
      callUs: "Ligar ao Restaurante",
      whatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Mediterrâneo de dia. Na pedra à noite.",
      quickLinks: "Ligações Rápidas",
      contact: "Contacto",
      follow: "Desde 2004 · Vilamoura",
      madeBy: "Feito por",
      agency: "Soluções Romanas",
      rights: "Todos os direitos reservados.",
    },
    whatsappMessage: "Olá! Gostaria de reservar uma mesa no Monte Sol Stone Steak House.",
    fullMenu: {
      overline: "Carta Completa",
      title: "A Carta Completa.",
      subtitle: "Das entradas algarvias às sobremesas da casa. Ingredientes frescos e sazonais, selecionados diariamente.",
      seasonalNote: "Consulte as sugestões frescas do dia",
      subCategories: { pizzas: "Pizzas", kids: "Menu Infantil" },
      itemsLabel: "pratos",
    },
    inVilamoura: "Em Vilamoura",
    food: {
      "overline": "DA NOSSA COZINHA",
      "title": "Favoritos do Monte Sol.",
      "subtitle": "Da pedra quente aos sabores do Mediterrâneo.",
      "cta": "VER MENU COMPLETO",
      "swipe": "Deslize para descobrir",
      "previous": "Prato anterior",
      "next": "Próximo prato",
      "dishes": {
            "stone-steak": "Bife na Pedra",
            "monkfish-prawn-skewer": "Kebab de Tamboril com Camarão",
            "t-bone": "T-Bone",
            "monkfish-curry": "Caril de Tamboril",
            "garlic-prawns": "Camarões ao Alho"
      }
},
    events: {
      "overline": "DESPORTO AO VIVO",
      "title": "Grandes momentos. Melhor à mesa.",
      "paragraph": "Golf, Fórmula 1, MotoGP, futebol e grandes eventos selecionados em direto nos nossos ecrãs.",
      "supporting": "Pergunte-nos o que está a dar hoje.",
      "cta": "O QUE DÁ HOJE?",
      "whatsappMessage": "Olá! Gostaria de saber que eventos desportivos vão transmitir hoje no Monte Sol.",
      "sports": {
            "golf": "Golf",
            "formula1": "Fórmula 1",
            "motogp": "MotoGP",
            "football": "Futebol"
      }
},
  },
  fr: {
    nav: {
      events: "Sport en Direct",
      concept: "Notre Concept",
      menus: "Cartes",
      reviews: "Avis",
      location: "Accès",
      bookTable: "Réserver",
    },
    hero: {
      imageAlt: "La terrasse ensoleillée du Monte Sol",
      overline: "Vilamoura · Depuis 2004",
      headline: "L'Art de la Viande sur Pierre.",
      headlineAccent: "Monte Sol :",
      subheadline: "Une institution à Vilamoura depuis 20 ans. Du petit-déjeuner anglais aux pièces nobles sur pierre volcanique brûlante.",
      ctaMenu: "Voir la Carte",
      ctaBook: "Réserver une Table",
      scroll: "Découvrir",
    },
    concept: {
      imageAlt: "La salle du restaurant Monte Sol",
      overline: "Le Concept",
      title: "Une terrasse ensoleillée,\ndeux ambiances uniques.",
      quote: "Une affaire de famille depuis 2004 — une table à la fois.",
      signatureNote: "Un jardin méditerranéen au cœur de Vilamoura — là où le soleil rencontre la pierre et le savoir-faire.",
      paragraph1: "Le jour, profitez de notre terrasse extérieure en mode Café & Snack-Bar. Réputé pour notre petit-déjeuner anglais, brunch frais et cocktails au coucher du soleil.",
      paragraph2: "Le soir, le rituel commence. Une pierre volcanique chaude arrive à table pour une expérience de grillade unique. Vous grillez, nous servons le vin.",
      highlights: [
        { label: "Fondé", value: "2004" },
        { label: "Lieu", value: "Vilamoura, Algarve" },
        { label: "Signature", value: "Viande sur Pierre" },
        { label: "Ambiance", value: "Jardin Rustique-Chic" },
      ],
    },
    menu: {
      overline: "La Carte",
      title: "Du café du matin\naux braises de minuit.",
      subtitle: "Deux cuisines, un jardin. Découvrez notre café de jour et notre grill de soirée.",
      tabDay: "Jour · Snacks & Petit-déjeuner",
      tabNight: "Soir · Steak sur Pierre",
      dayHours: "10h00 — 18h00",
      nightHours: "18h00 — 00h00",
      dayDescription: "Matinées détendues, brunchs au jardin et cocktails au coucher du soleil.",
      nightDescription: "Pierre volcanique, vin rouge et le rituel d'un dîner mémorable.",
      categories: {
        breakfast: "Petit-Déjeuner & Brunch",
        snacks: "Snacks & Amuse-bouches",
        cocktails: "Cocktails",
        spirits: "Spiritueux",
        starters: "Entrées",
        mains: "Plats sur Pierre",
        desserts: "Desserts Maison",
      },
      ctaBook: "Réservez Votre Table",
      pricelessNote: "Produits de saison — demandez les suggestions du jour.",
    },
    reviews: {
      overline: "Paroles d'hôtes",
      title: "Cinq étoiles,\nune table chaleureuse.",
      subtitle: "Ce que les voyageurs recherchent en venant à la Marina.",
      badge: "Avis Google · 4,8",
    },
    location: {
      overline: "Nous Trouver",
      title: "Au pied de la colline,\nà quelques minutes de la Marina.",
      address: "Vilamoura, Quarteira",
      country: "Algarve, Portugal",
      phone: "+351 963 314 690",
      hoursTitle: "Horaires",
      hoursLine1: "Mardi — Dimanche · 10h — 00h",
      hoursLine2: "La cuisine ferme à 22h00",
      hoursLine3: "Fermé le lundi",
      openMaps: "Itinéraire",
      callUs: "Appeler",
      whatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Méditerranéen le jour. Sur pierre le soir.",
      quickLinks: "Liens Rapides",
      contact: "Contact",
      follow: "Depuis 2004 · Vilamoura",
      madeBy: "Réalisé par",
      agency: "Soluções Romanas",
      rights: "Tous droits réservés.",
    },
    whatsappMessage: "Bonjour ! Je souhaiterais réserver une table au Monte Sol Stone Steak House.",
    fullMenu: {
      overline: "Carte Completa",
      title: "La Carte Completa.",
      subtitle: "Des entrées de l'Algarve aux desserts maison. Tous nos produits sont frais et de saison.",
      seasonalNote: "Demandez nos suggestions du marché",
      subCategories: { pizzas: "Pizzas", kids: "Menu Enfant" },
      itemsLabel: "plats",
    },
    inVilamoura: "À Vilamoura",
    food: {
      "overline": "DE NOTRE CUISINE",
      "title": "Les incontournables du Monte Sol.",
      "subtitle": "De la pierre chaude aux saveurs méditerranéennes.",
      "cta": "VOIR LE MENU COMPLET",
      "swipe": "Faites défiler pour découvrir",
      "previous": "Plat précédent",
      "next": "Plat suivant",
      "dishes": {
            "stone-steak": "Steak sur pierre",
            "monkfish-prawn-skewer": "Kebab de Lotte aux Crevettes",
            "t-bone": "Steak T-Bone",
            "monkfish-curry": "Curry de lotte",
            "garlic-prawns": "Gambas à l’ail"
      }
},
    events: {
      "overline": "SPORT EN DIRECT",
      "title": "Les grands moments se partagent à table.",
      "paragraph": "Golf, Formule 1, MotoGP, football et une sélection de grands événements sportifs diffusés en direct sur nos écrans.",
      "supporting": "Demandez-nous le programme du jour.",
      "cta": "QUEL EST LE PROGRAMME DU JOUR ?",
      "whatsappMessage": "Bonjour ! Je souhaiterais savoir quels événements sportifs vous diffusez aujourd’hui au Monte Sol.",
      "sports": {
            "golf": "Golf",
            "formula1": "Formule 1",
            "motogp": "MotoGP",
            "football": "Football"
      }
},
  },
  es: {
    nav: {
      events: "Deporte en Directo",
      concept: "El Concepto",
      menus: "Cartas",
      reviews: "Opiniones",
      location: "Ubicación",
      bookTable: "Reservar",
    },
    hero: {
      imageAlt: "La terraza soleada de Monte Sol",
      overline: "Vilamoura · Desde 2004",
      headline: "El Arte de la Carne a la Piedra.",
      headlineAccent: "Monte Sol:",
      subheadline: "Tradición en Vilamoura desde hace 20 años. Sabores auténticos — del desayuno inglés a los mejores cortes en piedra volcánica.",
      ctaMenu: "Ver Carta",
      ctaBook: "Reservar Mesa",
      scroll: "Descubrir",
    },
    concept: {
      imageAlt: "El comedor de Monte Sol",
      overline: "El Concepto",
      title: "Una terraza al sol,\ndos formas de disfrutar.",
      quote: "Negocio familiar desde 2004 — una mesa a la vez.",
      signatureNote: "Un jardín mediterráneo en el corazón de Vilamoura — donde el sol se pone sobre la piedra y la tradición se siente en cada plato.",
      paragraph1: "De día, disfrute de nuestra terraza como Café y Snack Bar. Famosos por nuestro desayuno inglés, brunch fresco y cócteles al atardecer.",
      paragraph2: "Por la noche, el ritual comienza. Una piedra volcánica caliente llega a la mesa para una experiencia de parrilla única. Usted cocina, nosotros servimos el vino.",
      highlights: [
        { label: "Fundado", value: "2004" },
        { label: "Lugar", value: "Vilamoura, Algarve" },
        { label: "Estrella", value: "Carne a la Piedra" },
        { label: "Ambiente", value: "Jardín Rústico-Chic" },
      ],
    },
    menu: {
      overline: "La Carta",
      title: "Del café de la mañana\na las brasas de medianoche.",
      subtitle: "Dos cocinas, un jardín. Descubra nuestro café de día y nuestro grill de noche.",
      tabDay: "Día · Snacks y Desayuno",
      tabNight: "Noche · Carne a la Piedra",
      dayHours: "10:00 — 18:00",
      nightHours: "18:00 — 00:00",
      dayDescription: "Mañanas relajadas, brunchs en el jardín y cócteles al atardecer.",
      nightDescription: "Piedra volcánica, vino tinto y el ritual de una cena memorable.",
      categories: {
        breakfast: "Desayuno y Brunch",
        snacks: "Snacks y Tapas",
        cocktails: "Cócteles",
        spirits: "Bebidas Espirituosas",
        starters: "Entrantes",
        mains: "Platos a la Piedra",
        desserts: "Postres Caseros",
      },
      ctaBook: "Reserve Su Mesa",
      pricelessNote: "Carta de temporada — consulte las sugerencias del día.",
    },
    reviews: {
      overline: "Historias de Clientes",
      title: "Cinco estrellas,\nuna mesa acogedora.",
      subtitle: "Lo que los viajeros de la Marina y más allá vuelven a buscar.",
      badge: "Opiniones Google · 4,8",
    },
    location: {
      overline: "Cómo Llegar",
      title: "Al pie de la colina,\na minutos de la Marina.",
      address: "Vilamoura, Quarteira",
      country: "Algarve, Portugal",
      phone: "+351 963 314 690",
      hoursTitle: "Horario",
      hoursLine1: "Martes — Domingo · 10:00 — 00:00",
      hoursLine2: "Cocina cierra a las 22:00",
      hoursLine3: "Cerrado los lunes",
      openMaps: "Cómo Llegar",
      callUs: "Llamar",
      whatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Mediterráneo de día. A la piedra de noche.",
      quickLinks: "Enlaces Rápidos",
      contact: "Contacto",
      follow: "Desde 2004 · Vilamoura",
      madeBy: "Hecho por",
      agency: "Soluções Romanas",
      rights: "Todos los derechos reservados.",
    },
    whatsappMessage: "¡Hola! Me gustaría reservar una mesa en Monte Sol Stone Steak House.",
    fullMenu: {
      overline: "Carta Completa",
      title: "La Carta Completa.",
      subtitle: "De los entrantes algarvios a los postres caseros. Ingredientes frescos y de temporada.",
      seasonalNote: "Consulte las sugerencias del día",
      subCategories: { pizzas: "Pizzas", kids: "Menú Infantil" },
      itemsLabel: "platos",
    },
    inVilamoura: "En Vilamoura",
    food: {
      "overline": "DE NUESTRA COCINA",
      "title": "Los favoritos de Monte Sol.",
      "subtitle": "De la piedra caliente a los sabores del Mediterráneo.",
      "cta": "VER MENÚ COMPLETO",
      "swipe": "Desliza para descubrir",
      "previous": "Plato anterior",
      "next": "Plato siguiente",
      "dishes": {
            "stone-steak": "Carne a la piedra",
            "monkfish-prawn-skewer": "Kebab de Rape con Gambas",
            "t-bone": "Chuletón T-Bone",
            "monkfish-curry": "Curry de rape",
            "garlic-prawns": "Gambas al ajillo"
      }
},
    events: {
      "overline": "DEPORTE EN DIRECTO",
      "title": "Grandes momentos. Mejor en la mesa.",
      "paragraph": "Golf, Fórmula 1, MotoGP, fútbol y una selección de grandes eventos deportivos en directo en nuestras pantallas.",
      "supporting": "Pregúntenos qué se emite hoy.",
      "cta": "¿QUÉ SE EMITE HOY?",
      "whatsappMessage": "¡Hola! Me gustaría saber qué eventos deportivos van a transmitir hoy en Monte Sol.",
      "sports": {
            "golf": "Golf",
            "formula1": "Fórmula 1",
            "motogp": "MotoGP",
            "football": "Fútbol"
      }
},
  },
};

export const languages = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];
